import { render, staticRenderFns } from "./MaterDrawer.vue?vue&type=template&id=a50bda90"
import script from "./MaterDrawer.vue?vue&type=script&lang=js"
export * from "./MaterDrawer.vue?vue&type=script&lang=js"
import style0 from "./MaterDrawer.vue?vue&type=style&index=0&id=a50bda90&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports